module.exports = __webpack_public_path__ + "img/electricIcon.c52208b2.png";